/* unplugin-vue-components disabled */import script from "./peopleheader.vue?vue&type=script&lang=ts&setup=true"
export * from "./peopleheader.vue?vue&type=script&lang=ts&setup=true"

import "./peopleheader.vue?vue&type=style&index=0&id=dd2f0e46&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd2f0e46"]])

export default __exports__